import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { Status } from "@app/shared/enums";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { LocaleDateTime } from "@app/shared/pipes/locale-date-time";
import { SubRegion } from "@app/shared/classes/subRegion";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";

export enum TeamMessageFieldName {
  title = "title",
  body = "body",
  status = "status",
  countries = "countries",
  subRegion_Ids = "subRegion_Ids",
  subRegion_Id = "subRegion_Id",
  terminal_Ids = "terminal_Ids",
  driver_Ids = "driver_Ids",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  errorMessage = "errorMessage",
  teamMessage_Id = "teamMessage_Id",
  country = "country",
  subRegions = "subRegions",
  apexId = "apexId",
  fullName = "fullName",
  terminalId = "terminalId",
  terminal_id = "terminal_id",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  driverTerminals = "driverTerminals",
  targetOrganization = "targetOrganization",
  driverList = "driverList",
  readTime = "readTime",
  read = "read"
};

enum FieldLabel {
  TITLE = "ml_144010",
  BODY = "ml_144111",
  STATUS = "ml_144072",
  IS_DELETED = "ml_144063",
  COUNTRY = "ml_143912",
  SUB_REGION = "ml_143911",
  TERMINAL = "ml_144113",
  TERMINAL_NAME = "ml_143910",
  DRIVER_NAME = "ml_143908",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",
  TERMINAL_ID = "ml_143909",
  SEND_TO = "ml_144131",
  DRIVER_LIST = "ml_144132",
  READ_TIME = "ml_144133",
  IS_READ = "ml_144136"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.TITLE,
    name: TeamMessageFieldName.title,
    sort: true
  },
  {
    text: FieldLabel.SEND_TO,
    name: TeamMessageFieldName.targetOrganization,
    sort: false,
  },
  {
    text: FieldLabel.DRIVER_LIST,
    name: TeamMessageFieldName.driver_Ids,
    sort: false,
  },
  {
    text: CommonFieldLabel.ATTACHMENT,
    name: CommonFieldName.attachment,
    sort: false,
  },
  {
    text: FieldLabel.IS_DELETED,
    name: TeamMessageFieldName.status,
    sort: true,
  },
  {
    text: FieldLabel.CREATED_BY,
    name: TeamMessageFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: TeamMessageFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: TeamMessageFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: TeamMessageFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

export const TerminalListDataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.TERMINAL_ID,
    name: TeamMessageFieldName.terminalId,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: TeamMessageFieldName.terminalName,
    sort: true
  }
];

export const DriverReadListDataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_APEX_ID,
    name: TeamMessageFieldName.apexId,
    sort: true
  },
  {
    text: FieldLabel.DRIVER_NAME,
    name: TeamMessageFieldName.fullName,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: TeamMessageFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: TeamMessageFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: TeamMessageFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: TeamMessageFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.READ_TIME,
    name: TeamMessageFieldName.readTime,
    sort: true,
    pipe: LocaleDateTime
  }
];

const TeamMessageSearchByList: SearchByItem[] = [
  { searchBy: TeamMessageFieldName.title, searchByLabel: FieldLabel.TITLE },
  { searchBy: TeamMessageFieldName.body, searchByLabel: FieldLabel.BODY },
  { searchBy: TeamMessageFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: TeamMessageFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: TeamMessageFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: TeamMessageFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: TeamMessageFieldName.status, searchByLabel: FieldLabel.IS_DELETED, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: Status.INACTIVE, label: "ml_143931" }, { value: Status.ACTIVE, label: "ml_143932" }]
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetTeamMessageSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = TeamMessageSearchByList.slice();
  result[4].searchDropDownValue = terminals;
  result[5].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}

const TeamMessageReceiverDriversSearchByList: SearchByItem[] = [
  { searchBy: TeamMessageFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: TeamMessageFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: TeamMessageFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: TeamMessageFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: TeamMessageFieldName.read, searchByLabel: FieldLabel.IS_READ, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: true, label: "ml_143931" }, { value: false, label: "ml_143932" }]
  }
];

export const GetTeamMessageReceiverDriversSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = TeamMessageReceiverDriversSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}
